import { render, staticRenderFns } from "./AreaProtecaoAmbientalApa.vue?vue&type=template&id=70a28e96&lang=pug"
import script from "./AreaProtecaoAmbientalApa.vue?vue&type=script&lang=js"
export * from "./AreaProtecaoAmbientalApa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports